import { render } from "./MenuPopover.vue?vue&type=template&id=ea51c9ac"
import script from "./MenuPopover.vue?vue&type=script&lang=js"
export * from "./MenuPopover.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projets\\2023\\PNB\\GECD\\gecd-police-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__